export default "__VITE_ASSET__D2J97kfW__"